import PropTypes from 'prop-types';
import { getImage } from '@utils/imageHelper';
import { PlusTopologySource } from '@constants/index';
import { Spacings } from '@styles/index';
import { commas } from '@utils/textHelper';
import PreSubscriptionBanner from './PreSubscriptionBanner';

const imageProps = {
  src: getImage('pre_subscription_courses.svg'),
  size: Spacings.SPACING_12B
};

const PreSubscriptionContent = ({ source, topology, headerTitle, goalUID }) => {
  let preSubscriptionBannerTitle = '';
  let preSubscriptionBannerContent = '';
  if (source === PlusTopologySource.TOPICS) {
    preSubscriptionBannerTitle =
      topology.coursesCount > 0 ? 'Access more than' : '';
    if (topology.coursesCount === 0) {
      preSubscriptionBannerContent = 'New courses coming soon';
    } else if (topology.coursesCount === 1) {
      preSubscriptionBannerContent = `1 course for ${topology.name}`;
    } else {
      preSubscriptionBannerContent = `${commas(
        topology.coursesCount
      )}+ courses for ${topology.name}`;
    }
  } else {
    preSubscriptionBannerTitle = `In ${headerTitle}`;
    if (topology.upcomingCoursesThisMonth === 0) {
      preSubscriptionBannerContent = 'New courses coming soon';
    } else if (topology.upcomingCoursesThisMonth === 1) {
      preSubscriptionBannerContent = '1 course starting this month';
    } else {
      preSubscriptionBannerContent = `${commas(
        topology.upcomingCoursesThisMonth
      )}+ courses starting this month`;
    }
  }

  return (
    <PreSubscriptionBanner
      imageProps={imageProps}
      title={preSubscriptionBannerTitle}
      content={preSubscriptionBannerContent}
      goalUID={goalUID}
    />
  );
};

PreSubscriptionContent.propTypes = {
  source: PropTypes.string.isRequired,
  topology: PropTypes.objectOf(PropTypes.any).isRequired,
  headerTitle: PropTypes.string.isRequired,
  goalUID: PropTypes.string.isRequired
};

export default PreSubscriptionContent;
